import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Menu from '../myComponents/Menu';
import './SetupPlatformPage.css';
import Footer from '../myComponents/Footer';

const SetupWindowsPage = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [activeTab, setActiveTab] = useState(0);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="App">
      <div style={{ position: 'relative', zIndex: 1000 }}>
        <Menu />
      </div>
      
      <section className="platform-setup-section">
        <div className="platform-container">
          {/* Header */}
          <div className="platform-header">
            <div className="platform-breadcrumb">
              <Link to="/setup">
                ← Все инструкции
              </Link>
            </div>
            <h1 className="platform-title">Как установить VPN на Windows</h1>
            <p className="platform-description">
              RED BUTTON предлагает несколько способов для подключения к VPN на компьютерах Windows. <br/><br/>
              Мы рекомендуем современное приложение INCY — работает в режиме TUN, что обеспечивает стабильное соединение для всех приложений в системе, включая игры, мессенджеры и стриминговые сервисы.
            </p>
          </div>

          {/* App Tabs */}
          <div className="app-tabs">
            <div
              className={`tab ${activeTab === 0 ? 'active' : ''}`}
              onClick={() => setActiveTab(0)}
            >
              ⚡ INCY
            </div>
            <div
              className={`tab ${activeTab === 1 ? 'active' : ''}`}
              onClick={() => setActiveTab(1)}
            >
              Hiddify
            </div>
            <div
              className={`tab ${activeTab === 2 ? 'active' : ''}`}
              onClick={() => setActiveTab(2)}
            >
              NekoRay
            </div>
          </div>

          {/* Setup Steps */}
          <div className="setup-steps">
            
            {/* INCY Tab */}
            {activeTab === 0 && (
              <>
                <div className="tab-text-content">
                  <p>INCY — современный VPN-клиент для Windows. Работает в режиме TUN, поэтому весь трафик системы автоматически проходит через VPN — браузеры, игры, мессенджеры, стриминговые сервисы. Не нужно ничего настраивать вручную.</p>

                  <h1>⚡ Установка INCY</h1>
                  <p>Скачайте установщик INCY с официального GitHub репозитория. Установка стандартная, как у любой программы Windows.</p>

                  <div className="section-button">
                    <a href="https://github.com/INCY-DEV/incy-platforms/releases/latest" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать INCY для Windows
                        </button>
                    </a>
                  </div>

                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот или который виден в личном кабинете на сайте.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>

                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram-бот или в личный кабинет на сайте</li>
                        <li>Сразу после оплаты вы получите Subscription Link</li>
                        <li>В боте: раздел «Мои конфигурации» → «Общая подписка»</li>
                        <li>Кликните один раз на ссылку, чтобы скопировать</li>
                        <li>Также можно использовать QR-код</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Подключение VPN</h1>
                  <p>Запустите INCY. Нажмите «+» или «Добавить подписку», вставьте скопированный Subscription Link. Приложение автоматически подгрузит список серверов. Выберите сервер и нажмите кнопку подключения. При первом запуске Windows запросит разрешение на установку TUN-адаптера — подтвердите.</p>
                  <p><strong>Если возникают проблемы с подключением — запустите INCY от имени администратора</strong> (правый клик по exe → «Запуск от имени администратора»).</p>
                  <p>Готово! Весь системный трафик идёт через VPN. Подписка обновляется автоматически. ⚡</p>
                </div>
              </>
            )}

            {/* Hiddify Tab */}
            {activeTab === 1 && (
              <>
                <div className="tab-text-content">
                  <p>Для настройки RED BUTTON на компьютерах Windows вам потребуется приложение Hiddify и ключ доступа. Рекомендуем использовать именно Hiddify.</p>
                  
                  <h1>⚡ Установка Hiddify</h1>
                  <p>Скачайте и установите современное приложение Hiddify для Windows с удобным графическим интерфейсом.</p>
                  
                  <div className="section-button">
                    <a href="https://github.com/hiddify/hiddify-next/releases/latest/download/Hiddify-Windows-Setup-x64.exe" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать Hiddify
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                        <li>Вы также можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Настройка Hiddify</h1>
                  <p>Установите приложение как обычную Windows программу. Откройте Hiddify Next, нажмите "+" для добавления профиля. Выберите "Добавить из буфера обмена" и вставьте subscription-ссылку.</p>
                  <p>В настройках выберите регион "Россия" для того, что бы российских сайты работали напрямую без VPN или "Другой" для полного VPN.</p>

<p>Если у вас возникают проблемы с подключением, то необходимо: Перейти во вкладку Параметры конфигурации или Настройки, в разделе "DNS" установить Cloudflare (1.1.1.1) или Google DNS (8.8.8.8) для обхода блокировок провайдера.</p>
                  <p>Готово! Hiddify обеспечивает стабильное соединение. 🔒</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Пошаговая настройка Hiddify</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Скачайте установочный файл Hiddify для Windows</li>
                        <li>Запустите установочный файл и следуйте инструкциям</li>
                        <li>Откройте приложение Hiddify</li>
                        <li>Нажмите "+" для добавления нового профиля</li>
                        <li>Выберите "Добавить из буфера обмена"</li>
                        <li>Вставьте subscription-ссылку и нажмите "Добавить"</li>
                        <li>Выберите сервер и нажмите кнопку подключения</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/hiddify_win.png" alt="Скриншот: Hiddify Windows" />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* V2RayN Tab */}
            {activeTab === 2 && (
              <>
                <div className="tab-text-content">
                  <p>NekoRay - современное приложение для Windows с удобным графическим интерфейсом и поддержкой всех популярных протоколов.</p>
                  <p>Стабильная альтернатива с простой настройкой</p>
                  
                  <h1>Установка NekoRay</h1>
                  <p>Скачайте и установите бесплатное приложение NekoRay с официального GitHub репозитория.</p>
                  
                  <div className="section-button">
                    <a href="https://github.com/Mahdi-zarei/nekoray/releases/download/4.3.7/nekoray-4.3.7-2025-07-08-windows64.zip" target="_blank" rel="noopener noreferrer">
                        <button className="download-btn">
                        Скачать NekoRay
                        </button>
                    </a>
                  </div>
                  
                  <h1>Получение ключа</h1>
                  <p>После активации VPN скопируйте Subscription link, который прислал Telegram-бот.</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 0 ? 'active' : ''}`}
                    onClick={() => toggleSection(0)}
                  >
                    <h3>Получение ключа в личном кабинете</h3>
                    <span className="section-icon">
                      {activeIndex === 0 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 0 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Войдите в Telegram Бот</li>
                        <li>Сразу после оплаты бот прислал вам Subscription Link</li>
                        <li>Перейдите в раздел 'Мои конфигурации'</li>
                        <li>Откройте 'Общая подписка'</li>
                        <li>Кликните один раз на ссылку, чтобы ее скопировать</li>
                        <li>Вы также можете воспользоваться QR кодом</li>
                      </ol>
                      <div className="step-screenshot">
                        <img src="/assets/get_link.jpg" alt="Скриншот: Получение ключа" />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="tab-text-content">
                  <h1>Подключение VPN</h1>
                  <p>Распакуйте архив NekoRay в любую папку на компьютере. Запустите nekoray.exe от имени администратора. В главном окне нажмите "Program" → "Add profile from clipboard" и вставьте subscription-ссылку. Выберите сервер и нажмите "Start".</p>
                  <p>Готово! Теперь вы подключены к быстрому и надежному VPN. 🐱</p>
                </div>

                <div className="setup-section">
                  <button
                    className={`section-header ${activeIndex === 1 ? 'active' : ''}`}
                    onClick={() => toggleSection(1)}
                  >
                    <h3>Пошаговая настройка NekoRay</h3>
                    <span className="section-icon">
                      {activeIndex === 1 ? '−' : '+'}
                    </span>
                  </button>
                  
                  <div className={`section-content ${activeIndex === 1 ? 'active' : ''}`}>
                    <div className="section-content-inner">
                      <ol className="steps-list">
                        <li>Скачайте архив NekoRay с GitHub</li>
                        <li>Распакуйте архив в любую папку (например C:\NekoRay)</li>
                        <li>Запустите nekoray.exe от имени администратора</li>
                        <li>В главном окне нажмите "Program" → "Add profile from clipboard"</li>
                        <li>Вставьте subscription-ссылку в появившемся окне</li>
                        <li>Нажмите "OK" для импорта серверов</li>
                        <li>Выберите сервер из списка и нажмите "Start"</li>
                      </ol>
                    </div>
                  </div>
                </div>
              </>
            )}


          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SetupWindowsPage;